import React from "react";

export default function Error404() {
  return (
    <div>
      <h2>ERORRRRRRRRRRRRRRRRR</h2>
    </div>
  );
}
